import { WalletName } from '@solana/wallet-adapter-base';
import {
	Coin98WalletAdapter,
	CoinbaseWalletAdapter,
	MathWalletAdapter,
	PhantomWalletAdapter,
	SolflareWalletAdapter,
	SpotWalletAdapter,
	TrustWalletAdapter,
} from '@solana/wallet-adapter-wallets';

/**
 * 🚨 ADDING NEW WALLETS?? : If you're trying to add a new "custom" wallet (not a regular solana/react one from @solana/wallet-adapter-wallets) then look at  newWallets_README.md
 */

// # Types
export type DriftCustomWalletName = 'Email (Magic Link)' | 'AppKit' | 'Privy';

type CustomWalletNameKey =
	| 'MAGIC_AUTH_WALLET_ADAPTER_NAME'
	| 'APPKIT_WALLET_ADAPTER_NAME'
	| 'PRIVY_NATIVE_WALLET_ADAPTER_NAME';

export const DRIFT_CUSTOM_WALLET_OPTIONS: Record<
	CustomWalletNameKey,
	DriftCustomWalletName
> = {
	MAGIC_AUTH_WALLET_ADAPTER_NAME: 'Email (Magic Link)',
	APPKIT_WALLET_ADAPTER_NAME: 'AppKit',
	PRIVY_NATIVE_WALLET_ADAPTER_NAME: 'Privy',
};
export type DriftWalletName = DriftCustomWalletName | WalletName;

// This is the name that the actual AppKit social wallet uses
export const APPKIT_SOCIAL_WALLET_PROVIDER_NAME = 'AppKit';

export const WALLET_NAME_SQUADS_X = 'SquadsX';

/**
 * Wallets that should have embedded wallets disabled.
 * These wallets are incompatible with embedded wallet functionality.
 */
const EMBEDDED_WALLET_BLACKLIST: string[] = [WALLET_NAME_SQUADS_X];

/**
 * Checks if a wallet adapter name is blacklisted from using embedded wallets.
 */
export const isWalletBlacklistedForEmbeddedWallets = (
	walletAdapterName: string | undefined
): boolean => {
	if (!walletAdapterName) return false;
	return EMBEDDED_WALLET_BLACKLIST.includes(walletAdapterName);
};

interface IconVariants {
	light: string;
	dark: string;
}

interface DriftCustomWalletIcons {
	MAGIC_AUTH_WALLET_ADAPTER: string;
	APPKIT_WALLET_ADAPTER: IconVariants;
	PRIVY_NATIVE_WALLET_ADAPTER: IconVariants;
}

export const DRIFT_CUSTOM_WALLET_ICONS: DriftCustomWalletIcons = {
	MAGIC_AUTH_WALLET_ADAPTER: '/assets/icons/magic-auth-logo.svg',
	APPKIT_WALLET_ADAPTER: {
		light: '/assets/icons/reown-logo-negative.svg',
		dark: '/assets/icons/reown-logo.svg',
	},
	PRIVY_NATIVE_WALLET_ADAPTER: {
		light: '/assets/icons/big-wallets-light.svg',
		dark: '/assets/icons/big-wallets-dark.svg',
	},
};

// # Define solana/react wallet adapters
/**
 * A list of wallets to display in the wallet connection list.
 *
 * On SAGA the mobile wallet adapter will be added to the list automatically.
 *
 * The Wallet Provider should also be smart enough to add any other detected wallets to the list too.
 */
export const DRIFT_WALLET_PROVIDERS = [
	new PhantomWalletAdapter(),
	new SolflareWalletAdapter(),
	new CoinbaseWalletAdapter(),
	new SpotWalletAdapter(),
	new TrustWalletAdapter(),
	new MathWalletAdapter(),
	new Coin98WalletAdapter(),
];
